import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const listingsReportsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.LISTINGS_REPORTS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.LISTINGS_REPORTS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.LISTINGS_REPORTS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const listingReportReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.LISTING_REPORT_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.LISTING_REPORT_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.LISTING_REPORT_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { listingsReportsReducer, listingReportReducer };
